import { useRouter, type RouteLocationRaw } from 'vue-router'

export function useNavigate() {
  const router = useRouter()
  function navigateTo(path: RouteLocationRaw) {
    router.push(path)
  }
  return { navigateTo }
}
